<section class="details">
    <div ng-show="loading" class="loading">
        <i class="fa fa-circle-o-notch fa-spin wait-icon"></i>
        {{'task.loading'|translate}}
    </div>
    <div class="no-form-defined" ng-show="!loading && noFormDefined()">{{'taskConfig.noFormDefined'|translate}}</div>
    <form name="taskForm" class="body"></form>
</section>